import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WithdrawalVipComponent } from './withdrawal-vip.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { PipesModule } from 'src/app/pipes/pipes.module';



@NgModule({
  declarations: [
    WithdrawalVipComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    PipesModule
  ]
})
export class WithdrawalVipModule { }
